import { useEffect, useState } from "react";
import { api } from "./api";

const FALLBACK = { rating: 4.9, count: 1251 };

export function useReviewSummary() {
  const [summary, setSummary] = useState(FALLBACK);
  useEffect(() => {
    api
      .get("/reviews/summary")
      .then((r) => {
        if (r.data && r.data.count) setSummary(r.data);
      })
      .catch(() => {});
  }, []);
  return summary;
}

export const formatReviewCount = (n) => Number(n || FALLBACK.count).toLocaleString("en-US");
